export default "__VITE_ASSET__CrE4n4M6__"